import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7280b35a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StudioToggleWithLabel = _resolveComponent("StudioToggleWithLabel")!
  const _component_StudioInput = _resolveComponent("StudioInput")!
  const _component_StudioTextarea = _resolveComponent("StudioTextarea")!
  const _component_ModuleWrapper = _resolveComponent("ModuleWrapper")!

  return (_openBlock(), _createBlock(_component_ModuleWrapper, {
    moduleId: _ctx.moduleId,
    title: "Stage Navigation",
    onInitializeData: _ctx.initializeData
  }, {
    main: _withCtx(() => [
      _createElementVNode("div", null, [
        (!_ctx.isWebinar)
          ? (_openBlock(), _createBlock(_component_StudioToggleWithLabel, {
              key: 0,
              id: "rooms-tab-toggle",
              label: "Rooms Tab",
              subLabel: "If your event has rooms, showing the tab allows users view or enter your rooms at any time during the event.",
              class: "tw-mb-4",
              checked: _ctx.roomsTabEnabled,
              "onUpdate:checked": _ctx.handleRoomsTabToggle
            }, null, 8, ["checked", "onUpdate:checked"]))
          : _createCommentVNode("", true),
        (_ctx.roomsTabEnabled && !_ctx.isWebinar)
          ? (_openBlock(), _createBlock(_component_StudioInput, {
              key: 1,
              id: "custom-rooms-tab-title-input",
              label: "Rooms Tab Title",
              class: "tw-mb-7",
              maxlength: 50,
              modelValue: _ctx.roomsTabTitle,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = value => _ctx.editRoomsTabTitle(value))
            }, null, 8, ["modelValue"]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.isBoothsTabEnabled)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", null, [
              (!_ctx.isWebinar)
                ? (_openBlock(), _createBlock(_component_StudioToggleWithLabel, {
                    key: 0,
                    id: "booths-tab-toggle",
                    label: "Booths Tab",
                    subLabel: "If your event has booths, showing the tab allows users view or enter your booths at any time during the event.",
                    class: "tw-mb-4",
                    checked: _ctx.boothsTabEnabled,
                    "onUpdate:checked": _ctx.handleBoothsTabToggle
                  }, null, 8, ["checked", "onUpdate:checked"]))
                : _createCommentVNode("", true),
              (_ctx.boothsTabEnabled && !_ctx.isWebinar)
                ? (_openBlock(), _createBlock(_component_StudioInput, {
                    key: 1,
                    id: "custom-booths-tab-title-input",
                    label: "Booths Tab Title",
                    class: "tw-mb-7",
                    required: "",
                    maxlength: 50,
                    modelValue: _ctx.boothsTabTitle,
                    inlineError: !_ctx.boothsTabTitle ? 'This field is required' : '',
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = value => _ctx.editBoothsTabTitle(value))
                  }, null, 8, ["modelValue", "inlineError"]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.boothsTabEnabled)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (!_ctx.isWebinar)
                    ? (_openBlock(), _createBlock(_component_StudioToggleWithLabel, {
                        key: 0,
                        id: "secondary-booths-tab-toggle",
                        label: "Secondary Booths Tab",
                        subLabel: "Create a second, separate Booths tab inside your event. This can be useful for separating different types of booths (your company's vs. your sponsors', for example).",
                        class: "tw-mb-4",
                        checked: _ctx.secondaryBoothsTabEnabled,
                        "onUpdate:checked": _ctx.handleSecondaryBoothsTabToggle
                      }, null, 8, ["checked", "onUpdate:checked"]))
                    : _createCommentVNode("", true),
                  (_ctx.secondaryBoothsTabEnabled && !_ctx.isWebinar)
                    ? (_openBlock(), _createBlock(_component_StudioInput, {
                        key: 1,
                        id: "custom-secondary-booths-tab-title-input",
                        label: "Secondary Booths Tab Title",
                        class: "tw-mb-7",
                        maxlength: 50,
                        modelValue: _ctx.secondaryBoothsTabTitle,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = value => _ctx.editSecondaryBoothsTabTitle(value))
                      }, null, 8, ["modelValue"]))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        _createVNode(_component_StudioToggleWithLabel, {
          id: "speakers-tab-toggle",
          label: "Speakers Tab",
          subLabel: "Let your audience see the list of all speakers in your event.",
          class: "tw-mb-4",
          checked: _ctx.speakersTabEnabled,
          "onUpdate:checked": _ctx.handleSpeakersTabToggle
        }, null, 8, ["checked", "onUpdate:checked"]),
        (_ctx.speakersTabEnabled)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_StudioInput, {
                id: "speakers-tab-title-input",
                label: "Speakers Tab Title",
                class: "tw-mb-4",
                maxlength: 50,
                modelValue: _ctx.speakersTabTitle,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = value => _ctx.editSpeakersTabTitle(value))
              }, null, 8, ["modelValue"]),
              (_ctx.isWebinar)
                ? (_openBlock(), _createBlock(_component_StudioTextarea, {
                    key: 0,
                    id: "speaker-tab-description",
                    class: "tw-mb-7",
                    modelValue: _ctx.speakerTabDescription,
                    label: "Speaker Tab Description",
                    maxlength: 137,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = description => _ctx.editSpeakersTabDescription(description))
                  }, null, 8, ["modelValue"]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_StudioToggleWithLabel, {
          id: "attendees-tab-toggle",
          label: "Attendees Tab",
          subLabel: "When the Attendees tab is turned on, attendees can view each other’s names, photos, title, company, and event status (currently attending, not attending). This tab is hidden in on-demand mode.",
          class: "tw-mb-4",
          checked: _ctx.attendeesTabEnabled,
          "onUpdate:checked": _ctx.handleAttendeesTabToggle
        }, null, 8, ["checked", "onUpdate:checked"]),
        _createVNode(_Transition, { name: "accordion" }, {
          default: _withCtx(() => [
            _withDirectives(_createVNode(_component_StudioToggleWithLabel, {
              id: "attendees-tab-enabled-for-speakers-toggle",
              label: "Attendees Tab for Speakers",
              subLabel: "If enabled, only speakers will be able to see the Attendees tab in the event. Speakers can view all attendee names, photos, title, company, and event status (currently attending, not attending).",
              class: "tw-mb-4",
              checked: _ctx.attendeesTabEnabledForSpeakers,
              "onUpdate:checked": _ctx.handleAttendeesTabEnabledForSpeakersToggle
            }, null, 8, ["checked", "onUpdate:checked"]), [
              [_vShow, !_ctx.attendeesTabEnabled]
            ])
          ]),
          _: 1
        }),
        (_ctx.attendeesTabEnabled || _ctx.attendeesTabEnabledForSpeakers)
          ? (_openBlock(), _createBlock(_component_StudioInput, {
              key: 0,
              id: "attendees-tab-title-input",
              label: "Attendees Tab Title",
              maxlength: 50,
              class: "tw-mb-4",
              modelValue: _ctx.attendeesTabTitle,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = value => _ctx.editAttendeesTabTitle(value))
            }, null, 8, ["modelValue"]))
          : _createCommentVNode("", true)
      ]),
      (!_ctx.isWebinar)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_StudioToggleWithLabel, {
              id: "attendees-profile-toggle",
              label: "Attendee Profiles",
              subLabel: "If enabled, attendee's name will display their Profile information, which may include their name, profile picture, company, title, location, Linkedin, X (twitter)",
              class: "tw-mb-4",
              checked: _ctx.attendeesProfileEnabled,
              "onUpdate:checked": _ctx.handleAttendeesProfileToggle
            }, null, 8, ["checked", "onUpdate:checked"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["moduleId", "onInitializeData"]))
}